import React from "react";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// components

// pages
import Layout from "./components/Layout/Layout";

// context
import { useUserState } from "./context/UserContext";
import Login from "./pages/login/Login";

export default function App() {
  // global
  var { isAuthenticated } = useUserState();

  return (
    <>       
      <HashRouter>        
        <Switch>
          <Route exact path="/" render={() => <Login />} />
          <Route
          exact
          path="/app"
          render={() => <Redirect to="/app/home" />}
          />
          <PrivateRoute path="/app" component={Layout} />
          <PublicRoute path="/login" component={Login} />
          <Route component={Error} />
        </Switch>
      </HashRouter>
    </>
  );

  // #######################################################################

  function PrivateRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            React.createElement(component, props)
          ) : (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          )
        }
      />
    );
  }

  function PublicRoute({ component, ...rest }) {
    return (
      <Route
        {...rest}
        render={props =>
          isAuthenticated ? (
            <Redirect
              to={{
                pathname: "/",
              }}
            />
          ) : (
            React.createElement(component, props)
          )
        }
      />
    );
  }
}
